package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class StudentEnrollmentBulkResponse(
    @SerialName("success")
    val success: Boolean? = null,
    @SerialName("message")
    val message: String? = null,
    @SerialName("students_created")
    val studentsCreated: Int? = null,
    @SerialName("students_failed")
    val studentsFailed: Int? = null,
    @SerialName("students_errors")
    val studentsErrors: List<String>? = null,
    @SerialName("parents_created")
    val parentsCreated: Int? = null,
    @SerialName("parents_failed")
    val parentsFailed: Int? = null,
    @SerialName("parents_errors")
    val parentsErrors: List<String>? = null,
    @SerialName("enrollments_created")
    val enrollmentsCreated: Int? = null,
    @SerialName("enrollments_failed")
    val enrollmentsFailed: Int? = null,
    @SerialName("enrollments_errors")
    val enrollmentsErrors: List<String>? = null
)
